export default __webpack_public_path__ + "static/media/icon-report-inflow.a53d61fa.png";